import React, { useState, useEffect, useRef } from 'react';
import { applyUpdate } from './service_worker_registration';

const POLL_INTERVAL = 3 * 60 * 1000;

const NewVersionBanner = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [updating, setUpdating] = useState(false);
  const currentVersion = useRef(process.env.REACT_APP_COMMIT_ID);

  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') return;
    if (!currentVersion.current) return;

    const check = () => {
      fetch('/version.json', { cache: 'no-store' })
        .then((r) => r.json())
        .then(({ version }: { version: string }) => {
          if (version && version !== currentVersion.current) {
            console.log(`version check — bundle: ${currentVersion.current}, server: ${version}`);
            setUpdateAvailable(true);
          }
        })
        .catch(() => {});
    };

    check();
    const interval = setInterval(check, POLL_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  if (!updateAvailable) return null;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999,
      backgroundColor: '#0d6b9a', color: 'white', padding: '10px 20px',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      gap: '16px', fontSize: '15px',
    }}>
      <span>A new version of Joy Metrics is available. Click Refresh to continue.</span>
      <button
        onClick={() => { setUpdating(true); applyUpdate(); }}
        disabled={updating}
        style={{
          backgroundColor: 'white', color: '#0d6b9a', border: 'none',
          padding: '4px 16px', borderRadius: '4px', fontWeight: 'bold', cursor: 'pointer',
        }}
      >
        {updating ? 'Updating…' : 'Refresh'}
      </button>
    </div>
  );
};

export default NewVersionBanner;
